import React from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Toggle from 'react-toggle';
import Select from 'react-select-plus';
import 'react-select-plus/dist/react-select-plus.css';
import {
  Modal,
  Button,
  Dropdown,
  MenuItem,
  Tooltip,
  OverlayTrigger,
  Row,
  Col
} from 'react-bootstrap';

import Comments from './Comments';
import AttachmentsForm from '../common_components/attachments/AttachmentsForm';
import Todos from './Todos';
import Editable from './Editable.jsx';
import Labels from './Labels';
import Activities from './Activities';
import CommentForm from './CommentForm';
import UserSelect from '../common_components/UserSelect';
import Relations from './Relations';
import { NOTE_MAX_LENGTH, PRIORITIES, COMPLEXITY } from './constants';
import ButtonWithConfirmation from '../common_components/ButtonWithConfirmation';
import NoteAlarm from './NoteAlarm';
import AITextEditor from '../AITextEditor';

@inject('rootStore')
@observer
class NoteModal extends React.Component {
  constructor(props) {
    super(props);
    // if currentNote is note provided, get the note by id

    if (!props.rootStore.currentNote && props.match.params.noteId) {
      props.rootStore.currentNote = props.rootStore.findNoteById(
        Number(props.match.params.noteId)
      );

      // clean route in case of incorrect url
      if (!props.rootStore.currentNote) {
        this.goBack();
      }
    }

    if (!props.rootStore.currentNote) {
      return;
    }
    this.note = props.rootStore.currentNote;
    this.canEdit = props.rootStore.authorizationStore.canEditNote(this.note);
    this.canEditPriority = props.rootStore.authorizationStore.canEditNotePriority(
      this.note
    );
    this.canEditComplexity = props.rootStore.authorizationStore.canEditNoteComplexity(
      this.note
    );
    this.canDelete = props.rootStore.authorizationStore.canDeleteNote(
      this.note
    );

    this.state = {
      dueDate: this.note.finishDate,
      renderListChangeItems: false,
      showComments: false,
      selectedMvp: undefined,
      selectedLane: undefined,
      advancedMode: false
    };
  }

  render() {
    if (!this.note) {
      return null;
    }

    const { intl, match, history, rootStore } = this.props;
    const { note } = this;
    const { formatMessage } = intl;

    const {
      description,
      name,
      comments,
      attachments,
      creator,
      last_user: lastUser,
      labels,
      finishDate,
      priority,
      todoList,
      assignee,
      createdAt,
      updatedAt
    } = note;

    const creatorFullNameTooltip = (
      <Tooltip id="fullNameTooltip">{creator.name}</Tooltip>
    );

    return (
      <Modal
        className="react-board note-modal-container"
        bsSize="large"
        show
        onHide={this.handleCancelClick}
      >
        <Row className="note-modal-body-container gray-background">
          <Modal.Header className="note-modal-header-container">
            <button
              type="button"
              className="close note-close-button"
              onClick={this.handleCancelClick}
            >
              <span className="glyphicon glyphicon-remove" />
            </button>

            <div className="centered">
              <img
                className="note-creator-photo"
                src={creator.profilePhotoUrl}
              />
              <br />
              <OverlayTrigger
                placement="bottom"
                overlay={creatorFullNameTooltip}
              >
                <span>{note.creatorShortName}</span>
              </OverlayTrigger>
              &nbsp;&nbsp;
              <span>
                {intl.formatRelative(createdAt)}
                &nbsp;
              </span>
            </div>
          </Modal.Header>

          <Col sm={8} className="note-modal-left-col-container">
            <Modal.Body>
              <div className="note-modal-name-container">
                <Editable
                  value={note.name}
                  placeholder={intl.formatMessage({ id: 'add_title' })}
                  canDelete={false}
                  canEdit={this.canEdit}
                  onEdit={value => note.editNoteName(value)}
                  maxLength={NOTE_MAX_LENGTH}
                />
              </div>
              <div className="note-modal-description-container">
                {this.canEdit ? (
                  <AITextEditor
                    value={note.description || ''}
                    onChange={value => note.editNoteDescription(value)}
                    placeholder={intl.formatMessage({
                      id: 'add_optional_description'
                    })}
                    context={this.buildTaskContext(note, intl)}
                    rows={4}
                  />
                ) : (
                  <Editable
                    value={note.description}
                    placeholder={intl.formatMessage({
                      id: 'add_optional_description'
                    })}
                    canDelete={false}
                    canEdit={this.canEdit}
                    onEdit={value => note.editNoteDescription(value)}
                    maxLength={NOTE_MAX_LENGTH}
                  />
                )}
              </div>

              {todoList && (
                <div
                  className="note-modal-todos-container"
                  style={{ marginTop: '25px' }}
                >
                  <Todos note={note} />
                </div>
              )}

              <div
                className="note-modal-attachments-container"
                style={{ marginTop: '25px' }}
              >
                <AttachmentsForm attachable={note} renderHidePreview />
              </div>

              <hr />
              <h4>{intl.formatMessage({ id: 'activity' })}</h4>
              {this.renderCommentsActivitySwitch()}

              <br />
            </Modal.Body>
          </Col>

          <Col sm={4} className="note-modal-right-col-container">
            <Modal.Body>
              {(true || !note.laneStore.rootStore.isCeoBoard) && (
                <div>
                  {this.renderAssignee()}
                  {this.renderResponsibleTeam()}
                  <hr />
                </div>
              )}

              {this.renderDueDateContainer()}
              <hr />

              {this.renderPriority()}
              <hr />

              {this.renderComplexity()}
              <hr />

              {this.renderSectionTitle('tags', 'fa fa-tags')}
              <Labels note={note} />
              <hr />

              <span
                style={{
                  verticalAlign: 'top',
                  marginRight: '5px',
                  marginBottom: '10px'
                }}
              >
                {intl.formatMessage({ id: 'show_advanced_mode' })}
              </span>
              <Toggle onChange={this.toggleAdvancedMode} />

              {this.state.advancedMode && (
                <div>
                  {this.renderMoveNote()}
                  <hr />
                </div>
              )}

              {this.state.advancedMode && (
                <div>
                  {this.renderNoteAlarm()}
                  <hr />
                </div>
              )}

              {this.state.advancedMode && (
                <React.Fragment>
                  {this.renderSectionTitle('relations', 'fa fa-files-o')}
                  <Relations note={note} />
                  <hr />
                </React.Fragment>
              )}

              {this.canDelete && this.renderDeleteButton()}
            </Modal.Body>
          </Col>
        </Row>
      </Modal>
    );
  }

  renderPriority = () => {
    const { priority } = this.note;
    const { intl } = this.props;

    if (this.canEdit || (priority !== 'low_priority' && !this.canEdit)) {
      return (
        <div style={{ marginTop: '20px' }}>
          {this.renderSectionTitle('priority', 'fa fa-angle-double-up')}

          {this.canEditPriority ? (
            <div className="note-priority-buttons-container">
              {this.renderPriorityButton(PRIORITIES.LOW)}
              &nbsp;
              {this.renderPriorityButton(PRIORITIES.MEDIUM)}
              &nbsp;
              {this.renderPriorityButton(PRIORITIES.HIGH)}
            </div>
          ) : (
            this.renderPriorityButton(priority, priority)
          )}
        </div>
      );
    }
  };

  renderComplexity = () => {
    const { intl } = this.props;

    if (this.canEdit) {
      return (
        <div style={{ marginTop: '20px' }}>
          {this.renderSectionTitle('complexity', 'fa fa-tachometer')}

          {this.canEditComplexity ? (
            <Select
              value={this.note.complexity}
              options={[
                COMPLEXITY.EASY,
                COMPLEXITY.MEDIUM,
                COMPLEXITY.HARD
              ].map(v => ({
                value: v,
                label: intl.formatMessage({ id: v })
              }))}
              onChange={this.onNoteComplexityChange}
            />
          ) : (
            this.renderComplexityButton(
              this.note.complexity,
              this.note.complexity
            )
          )}
        </div>
      );
    }
  };

  renderPriorityButton = newPriority => {
    const { priority } = this.note;
    const { intl } = this.props;

    return (
      <Button
        className={`btn ${newPriority}-btn`}
        disabled={!this.canEditPriority}
        active={priority === newPriority}
        onClick={this.onNotePriorityChange.bind(null, newPriority)}
      >
        {intl.formatMessage({ id: newPriority })}
      </Button>
    );
  };

  renderComplexityButton = newComplexity => {
    const { complexity } = this.note;
    const { intl } = this.props;

    return (
      <Button
        className={`btn ${newComplexity}-btn`}
        disabled={!this.canEditComplexity}
        active={complexity === newComplexity}
        onClick={this.onNoteComplexityChange.bind(null, newComplexity)}
      >
        {intl.formatMessage({ id: newComplexity })}
      </Button>
    );
  };

  renderMoveNote = () => {
    const { rootStore, intl } = this.props;

    if (rootStore.isCeoBoard) {
      return null;
    }

    const { note } = this;
    const { selectedMvp, selectedLane } = this.state;
    const selectStyle = { marginBottom: '5px' };
    const selected = selectedMvp || selectedLane;
    const disabled = !this.canEdit;

    return (
      <div className="note-modal-move-to-board-container">
        {this.renderSectionTitle('move_task', 'fa fa-share')}

        <Select
          options={note.selectableLanesOptions}
          value={selectedLane}
          onChange={selectedLane => this.setState({ selectedLane })}
          placeholder={intl.formatMessage({ id: 'to_another_lane' })}
          wrapperStyle={selectStyle}
          disabled={!!selectedMvp}
          clearable
        />

        <Select
          options={rootStore.mvpsSelectOptions}
          value={selectedMvp}
          onChange={selectedMvp => this.setState({ selectedMvp })}
          placeholder={intl.formatMessage({ id: 'to_another_mvp' })}
          wrapperStyle={selectStyle}
          disabled={!!selectedLane}
          clearable
        />

        <Button
          bsStyle="primary"
          block
          disabled={!selected || disabled}
          onClick={this.handleMoveButton}
        >
          {' '}
          {intl.formatMessage({ id: 'move' })}{' '}
        </Button>
      </div>
    );
  };

  renderNoteAlarm = () => {
    const { note } = this;

    if (!note.noteAlarm) {
      return;
    }

    return (
      <div className="note-modal-note-alarm-container">
        {this.renderSectionTitle('repetitive_task', 'fa fa-bell-o')}

        <NoteAlarm note={note} />
      </div>
    );
  };

  handleMoveButton = () => {
    const { selectedMvp, selectedLane } = this.state;
    const { note } = this;

    const selected = selectedMvp || selectedLane;

    if (selected) {
      note.moveNoteToLane(selected.value, !!selectedLane);
      this.goBack();
    }
  };

  renderDeleteButton = () => {
    const { intl, note, onDelete } = this.props;
    const { formatMessage } = intl;

    const confirmation = formatMessage({ id: 'are_you_sure_delete_card' });
    const okLabel = formatMessage({ id: 'delete' });
    const cancelLabel = formatMessage({ id: 'cancel' });

    return (
      <ButtonWithConfirmation
        confirmationMessage={confirmation}
        option1Label={cancelLabel}
        option2Label={okLabel}
        onOption2Select={this.onDelete}
        dropdownClassname="btn-block"
        toggleButtonClassName="btn-block"
      >
        {okLabel}
      </ButtonWithConfirmation>
    );
  };

  renderDueDateContainer = () => {
    const { rootStore, intl } = this.props;
    const { note } = this;
    const { finishDate } = note;
    const { moment } = rootStore.localeStore;

    if (this.canEdit || (finishDate && !this.canEdit)) {
      const selectedDate = finishDate ? moment(finishDate) : null;

      return (
        <div className="note-modal-due-date-container">
          {this.renderSectionTitle('due_date', 'fa fa-calendar-check-o')}

          <DatePicker
            showTimeSelect
            dateFormat="LLL"
            timeFormat="HH:mm"
            selected={selectedDate}
            onChange={this.onDueDateChange}
            disabled={!this.canEdit}
            readOnly
            timeCaption={intl.formatMessage({ id: 'time' })}
            todayButton={intl.formatMessage({ id: 'today' })}
            ref={elem => (this.datePickerRef = elem)}
            placeholderText={intl.formatMessage({ id: 'assign_due_date' })}
            className="form-control"
          >
            <div>
              <Button
                block
                onClick={() => {
                  this.datePickerRef.clear();
                  this.datePickerRef.setOpen();
                }}
              >
                {intl.formatMessage({ id: 'clear_due_date' })}
              </Button>
            </div>
          </DatePicker>
        </div>
      );
    }
  };

  // renderListChangeDropdown = () => {
  //     const {intl} = this.props;
  //     const note = this.note;
  //     const {formatMessage} = intl;
  //
  //     return (
  //         <Dropdown id="modal-change-lane-dropdown">
  //             <Dropdown.Toggle onClick={() => this.setState({renderListChangeItems: true})}>
  //                 {formatMessage({id: 'move_to_dropdown_header'})}
  //             </Dropdown.Toggle>
  //             <Dropdown.Menu>
  //                 <MenuItem header>{formatMessage({id: 'move_to_dropdown_header'})}</MenuItem>
  //                 {this.state.renderListChangeItems && (
  //                     note.laneStore.rootStore.lanes.map((lane) => (
  //                         <MenuItem
  //                             key={lane.id}
  //                             eventKey={lane}
  //                             onSelect={this.handleChangeListSelect}
  //                             disabled={note.laneStore.id === lane.id}>
  //                             {formatMessage({id: lane.rootStore.boardType + '-' + lane.name})}
  //                         </MenuItem>
  //                     )))}
  //
  //             </Dropdown.Menu>
  //         </Dropdown>
  //     );
  // };

  renderAssignee = () => {
    const { intl } = this.props;
    const { note } = this;
    const isAssignee = this.note.assignee;
    const title = isAssignee ? 'note_assigned_to' : 'note_unassigned';
    const show = isAssignee || this.canEdit || true;

    // console.log(this.note.assignee);

    return (
      <React.Fragment>
        {show && this.renderSectionTitle(title, 'fa fa-user-circle')}

        {show && (
          <UserSelect
            users={note.allMembersWithoutAssignee}
            value={this.note.assignee}
            onChange={this.handleChangeAssigneeSelect}
            multi={false}
            placeholder={intl.formatMessage({ id: 'assign_task_to' })}
            // disabled={!this.canEdit}
          />
        )}
      </React.Fragment>
    );
  };

  renderResponsibleTeam = () => {
    const { intl } = this.props;
    const { note } = this;
    const isTeamAssignees = !!this.note.teamAssignees.length;

    return (
      <React.Fragment>
        {isTeamAssignees && (
          <h4>{intl.formatMessage({ id: 'note_assigned_to_team' })}</h4>
        )}

        {(isTeamAssignees || this.canEdit) && (
          <UserSelect
            users={note.allMembersWithoutTeamAssignees}
            value={this.note.teamAssignees}
            onChange={this.handleChangeTeamAssigneesSelect}
            multi
            placeholder={intl.formatMessage({ id: 'team_assignees' })}
            disabled={!this.canEdit}
            style={{ marginTop: '5px' }}
          />
        )}
      </React.Fragment>
    );
  };

  renderCommentsActivitySwitch = () => {
    const { intl } = this.props;
    const { note } = this;

    return (
      <React.Fragment>
        <span
          style={{
            verticalAlign: 'top',
            marginRight: '5px',
            marginBottom: '10px'
          }}
        >
          {intl.formatMessage({ id: 'see_conversation_only' })}
        </span>
        <Toggle onChange={this.toggleShowComments} />

        <br />

        <CommentForm note={note} />

        <br />

        {!this.state.showComments ? (
          <Comments comments={note.comments} note={note} />
        ) : (
          <Activities note={note} />
        )}
      </React.Fragment>
    );
  };

  renderSectionTitle = (title, iconClassName) => {
    const { intl } = this.props;
    const titleStyle = {
      marginTop: '25px',
      fontWeight: 'bold',
      color: '#636363'
    };
    const iconStyle = {
      fontSize: '1.5rem',
      marginRight: '7px',
      verticalAlign: 'middle',
      color: '#959595'
    };

    return (
      <h5 style={titleStyle}>
        {iconClassName && (
          <span
            className={iconClassName}
            style={iconStyle}
            aria-hidden="true"
          />
        )}
        {intl.formatMessage({ id: title })}
      </h5>
    );
  };

  onDelete = () => {
    const { note } = this;

    note.destroy();
    this.goBack();
  };

  handleChangeAssigneeSelect = (member, e) => {
    this.note.editAssignee(member);
  };

  handleChangeTeamAssigneesSelect = members => {
    this.note.editTeamAssignees(members);
  };

  handleChangeListSelect = (lane, e) => {
    // const {history} = this.props;
    // note.hideNoteModal();

    lane.moveNoteFromDropdown(this.note);

    // history.goBack();
    this.goBack();
  };

  onNotePriorityChange = priority => {
    const { rootStore } = this.props;
    const { note } = this;

    if (rootStore.authorizationStore.canChangeNotePriority(note, priority)) {
      note.editNotePriority(priority);
    }

    // TODO:    else show alert
  };

  onNoteComplexityChange = complexity => {
    const { rootStore } = this.props;
    const { note } = this;

    if (
      rootStore.authorizationStore.canChangeNoteComplexity(
        note,
        complexity.value
      )
    ) {
      note.editNoteComplexity(complexity.value);
    }
  };

  onDueDateChange = date => {
    // this.state.note.finish_date = date;
    // this.setState({dueDate: date});
    this.note.editDueDate(date);
  };

  // handleSaveClick = () => {
  //
  //     // const {history} = this.props;
  //     const note = this.note;
  //
  //     if (this.state.descriptionChanged) {
  //         this.setState({descriptionChanged: false});
  //         note.editNoteDescription(this.state.description);
  //     }
  //
  //     if (this.state.nameChanged) {
  //         this.setState({nameChanged: false});
  //         note.editNoteName(this.state.name);
  //     }
  //
  //     if (this.state.dueDateChanged) {
  //         this.setState({dueDateChanged: false});
  //         note.editDueDate(this.state.dueDate);
  //     }
  //
  //     if (this.state.priorityChanged) {
  //         this.setState({priorityChanged: false});
  //         note.editNotePriority(this.state.priority);
  //     }
  //
  //
  //     if (this.state.assigneeNameChanged) {
  //         this.setState({assigneeNameChanged: false});
  //         note.editAssignee(this.state.assigneeMember);
  //     }
  //
  //     // note.hideNoteModal();
  //     // history.goBack();
  //
  //     this.goBack();
  //
  //
  // };

  handleCancelClick = e => {
    if (e) {
      e.stopPropagation();
    }

    this.goBack();
  };

  goBack = () => {
    const { history, match } = this.props;

    let backUrl = match.url.substr(0, match.url.lastIndexOf('/'));

    backUrl = backUrl.substr(0, backUrl.lastIndexOf('/'));

    history.push(backUrl);
  };

  // canEdit(note) {
  //     if (typeof this.canEditNote === 'undefined') {
  //         return this.canEditNote = CAN_EDIT_NOTE(note.rootStore, note);
  //     } else {
  //         return this.canEditNote;
  //     }
  // }

  // canDelete(note) {
  //     if (typeof this.canDeleteNote === 'undefined') {
  //         return this.canDeleteNote = CAN_DELETE_NOTE(note.rootStore, note);
  //     } else {
  //         return this.canDeleteNote;
  //     }
  // }

  // canEditPriority(note) {
  //     if (typeof this.canEditNotePriority === 'undefined') {
  //         return this.canEditNotePriority = CAN_EDIT_NOTE_PRIORITY(note.rootStore, note);
  //     } else {
  //         return this.canEditNotePriority;
  //     }
  // }

  toggleShowComments = () => {
    this.setState({ showComments: !this.state.showComments });
  };

  toggleAdvancedMode = () => {
    this.setState({ advancedMode: !this.state.advancedMode });
  };

  buildTaskContext = (note, intl) => {
    let context =
      'El texto con el que estás trabajando es sobre la descripción de una tarea en un tablero de gestión de proyectos.';

    // Add task title if available
    if (note.name && note.name.trim()) {
      context += ` La tarea se llama "${note.name}".`;
    }

    // Add priority information if available and not default
    if (note.priority && note.priority !== 'low_priority') {
      const priorityLabel = intl.formatMessage({
        id: note.priority,
        defaultMessage: note.priority
      });
      context += ` Tiene prioridad ${priorityLabel}.`;
    }

    // Add complexity information if available
    if (note.complexity && note.complexity !== 'easy') {
      const complexityLabel = intl.formatMessage({
        id: note.complexity,
        defaultMessage: note.complexity
      });
      context += ` Su complejidad es ${complexityLabel}.`;
    }

    // Add due date information if available
    if (note.finishDate) {
      const dueDate = intl.formatDate(note.finishDate, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
      context += ` Tiene fecha límite el ${dueDate}.`;
    }

    // Add assignee information if available
    if (note.assignee && note.assignee.name) {
      context += ` Está asignada a ${note.assignee.name}.`;
    }

    // Add labels information if available
    if (note.labels && note.labels.length > 0) {
      const labelNames = note.labels.map(label => label.name).join(', ');
      context += ` Tiene las etiquetas: ${labelNames}.`;
    }

    // Add guidance for task descriptions
    context +=
      ' Las descripciones de tareas deben ser claras, específicas y proporcionar suficiente detalle para que los miembros del equipo entiendan qué se debe hacer, cómo hacerlo y cuáles son los criterios de éxito.';

    return context;
  };
}

export default withRouter(injectIntl(NoteModal));
